import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes } from '@emotion/react';
import { N0, N60A } from '@atlaskit/theme/colors';
var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var shadowStyles = css({
  boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N60A, ", 0 0 1px ").concat(N60A), ")")
});
var rotationAnimation = keyframes({
  '0%': _objectSpread({
    '--gradient-angle': '0deg'
  }, isFirefox ? {
    backgroundPosition: '100%'
  } : {}),
  '100%': _objectSpread({
    '--gradient-angle': '360deg'
  }, isFirefox ? {
    backgroundPosition: '-100%'
  } : {})
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var prismBorderAnimationStyles = css({
  '&::before, &::after': _objectSpread(_objectSpread({
    animation: "".concat(rotationAnimation, " linear 2s infinite")
  }, isFirefox ? {
    animationDirection: 'normal',
    animationDuration: '1s'
  } : {}), {}, {
    '@media (prefers-reduced-motion)': {
      animation: 'none'
    }
  })
});

// ED-20633, DSP-14045: Avoid space tokens for now as space tokens are currently using rem units
// and Safari has a bug where rem is incorrectly calculated when there are
// animations involved
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
export var prismBorderStyles = function prismBorderStyles(aiThemeColor) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t// This style is used to define gradient angle around the border,\n\t// used widely across every modals with a prism border\n\t@property --gradient-angle {\n\t\tsyntax: '<angle>';\n\t\tinitial-value: 270deg;\n\t\tinherits: false;\n\t}\n\n\tposition: relative;\n\tborder-radius: ", ";\n\tbox-shadow: none;\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\t", "\n\t\tz-index: -1;\n\t\twidth: calc(100% + 2px);\n\t\theight: calc(100% + 2px);\n\t\ttop: -1px;\n\t\tleft: -1px;\n\t\tborder-radius: calc(", " + 1px);\n\n\t\t// Avoid css filter issues in Safari\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n\n\t&::after {\n\t\tfilter: blur(8px);\n\t\topacity: 0.5;\n\t}\n"])), "var(--ds-border-radius-200, 6px)", isFirefox ? "background: linear-gradient(90deg,\n          ".concat(aiThemeColor('prism.border.step.1'), " 0%,\n          ").concat(aiThemeColor('prism.border.step.2'), " 12%,\n          ").concat(aiThemeColor('prism.border.step.3'), " 24%,\n          ").concat(aiThemeColor('prism.border.step.4'), " 48%,\n          ").concat(aiThemeColor('prism.border.step.3'), " 64%,\n          ").concat(aiThemeColor('prism.border.step.2'), " 80%,\n          ").concat(aiThemeColor('prism.border.step.1'), " 100%\n        );\n        background-size: 200%;") : "\n      background: conic-gradient(\n      from var(--gradient-angle, 270deg),\n      ".concat(aiThemeColor('prism.border.step.1'), " 0%,\n      ").concat(aiThemeColor('prism.border.step.2'), " 20%,\n      ").concat(aiThemeColor('prism.border.step.3'), " 50%,\n      ").concat(aiThemeColor('prism.border.step.4'), " 56%,\n      ").concat(aiThemeColor('prism.border.step.1'), " 100%\n    );"), "var(--ds-border-radius-200, 6px)");
};
var borderStyles = css({
  borderRadius: "var(--ds-border-radius-200, 6px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '> :first-child': {
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '> :last-child': {
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit'
  }
});
var dimensionStyles = css({
  height: '100%',
  width: '100%',
  boxSizing: 'border-box'
});
var backgroundStyles = css({
  backgroundColor: "var(--ds-surface-overlay, ".concat(N0, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var floatingContainerStyles = [shadowStyles, borderStyles, dimensionStyles, backgroundStyles];
var defaultPadding = {
  top: 12,
  bottom: 12,
  left: 12,
  right: 12
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var defaultPaddingStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  padding: "".concat(defaultPadding.top, "px ").concat(defaultPadding.left, "px")
});
export var getPaddingAdjustments = function getPaddingAdjustments(adjustments) {
  if (!adjustments) {
    return null;
  }
  var top = adjustments.top,
    right = adjustments.right,
    bottom = adjustments.bottom,
    left = adjustments.left;
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingTop: "".concat(defaultPadding.top + (top !== null && top !== void 0 ? top : 0), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingRight: "".concat(defaultPadding.right + (right !== null && right !== void 0 ? right : 0), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBottom: "".concat(defaultPadding.bottom + (bottom !== null && bottom !== void 0 ? bottom : 0), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: "".concat(defaultPadding.left + (left !== null && left !== void 0 ? left : 0), "px")
  });
};
export var scrollTopMargin = 32;
/**
 * Scroll margin is used to ensure that the modal won't be
 * too close to the top of the editor, which may sometimes
 * cover the modal slightly.
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var scrollMarginStyles = css({
  scrollMarginTop: "var(--ds-space-400, ".concat("".concat(scrollTopMargin, "px"), ")")
});